import { createStore, applyMiddleware, compose } from 'redux';
import { browserHistory } from 'react-router';
import createSagaMiddleware from 'redux-saga';
import { createEpicMiddleware } from 'redux-observable';
import { routerMiddleware, syncHistoryWithStore } from 'react-router-redux';
import rootReducer from './reducers/root';
import rootEpic from './epics/root_epic';
import * as institution_sagas from './sagas/institutions';
import * as auth_sagas from './sagas/auth';

const preparedRouterMiddleware = routerMiddleware(browserHistory);
const sagaMiddleware = createSagaMiddleware();
const epicMiddleware = createEpicMiddleware(rootEpic);

const middleware = [preparedRouterMiddleware, sagaMiddleware, epicMiddleware];

let store = createStore(
    rootReducer,
    {},
    compose(
        applyMiddleware(...middleware),
        window.devToolsExtension ? window.devToolsExtension() : f => f
    )
);

export const getStore = () => store;
export const history = syncHistoryWithStore(browserHistory, getStore());

sagaMiddleware.run(auth_sagas.watchLogin);
sagaMiddleware.run(auth_sagas.watchLogout);
sagaMiddleware.run(auth_sagas.watchFetchUsers);
sagaMiddleware.run(auth_sagas.watchFetchUser);
sagaMiddleware.run(auth_sagas.watchSaveUser);
sagaMiddleware.run(auth_sagas.watchValidateRegistration);
sagaMiddleware.run(auth_sagas.watchRequestPassword);
sagaMiddleware.run(auth_sagas.watchResetPassword);

sagaMiddleware.run(institution_sagas.watchLoadCategories);
sagaMiddleware.run(institution_sagas.watchLoadDistricts);
sagaMiddleware.run(institution_sagas.watchSetActiveInstitution);
sagaMiddleware.run(institution_sagas.watchSetFilters);
sagaMiddleware.run(institution_sagas.watchEditInstitution);
sagaMiddleware.run(institution_sagas.watchSaveInstitution);



/** WEBPACK FOOTER **
 ** ./src/store.js
 **/